import { FlexContent, Tabs } from "@rothoblaas/design-system";
import { FC, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { useAuthContext } from "../../context/authContext";
import useI18n from "../../hooks/useTranslations";
import { useUsersApi } from "../../http/useUsers";
import Header from "../ui/Header";
import AdminUserAccessRules from "./AdminUserAccessRules";
import AdminUserGeneralData from "./AdminUserGeneralData";
import AdminUserPermissions from "./AdminUserPermissions";
import AdminUserUsage from "./AdminUserUsage";

export const AdminUser: FC = () => {
  const i18n = useI18n();
  const { userId } = useParams<{ userId: string }>();
  const aborter = useRef(new AbortController());
  const usersApi = useUsersApi();
  const { permissions } = useAuthContext();

  const { error, data, isMutating, trigger } = usersApi.getAdminUser(userId!, aborter.current.signal);

  useEffect(() => {
    userId && trigger();
  }, [userId]);

  const user = !error ? data : undefined;

  return (
    <>
      <Header
        title={i18n.translation.users.plural}
        path={[
          { display: i18n.translation.users.all, url: "/admin/users" },
          { display: !!data?.firstName && !!data?.lastName ? data?.firstName + " " + data?.lastName : "" },
        ]}
        error={error}
      />

      <FlexContent padding noPaddingTop>
        <Tabs
          renderMode="lazy"
          urlParameter="tab"
          hideBorderBottom
          tabs={[
            { title: i18n.translation.common.generalData },
            { title: i18n.translation.permissions.plural },
            { title: i18n.translation.accessControl.plural },
            { title: i18n.translation.usageStatistics.plural },
          ]}
          contents={[
            <AdminUserGeneralData user={user} />,
            <AdminUserPermissions
              user={user}
              disabled={(userId && (isMutating || !permissions.admin.canManageUsers)) || !!error}
            />,
            <AdminUserAccessRules userId={userId!} email={user?.email} />,
            <AdminUserUsage userId={userId!} />,
          ]}
        />
      </FlexContent>
    </>
  );
};
